import {
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  useTheme,
} from '@mui/material';

import CustomDialogModal from './Custom';

const InfoDialogModal = ({ isOpen, onClose, title, text, sx }) => {
  const theme = useTheme();

  return (
    <CustomDialogModal open={isOpen} onClose={onClose} sx={sx}>
      {title && <DialogTitle sx={{ color: theme.text2 }}>{title}</DialogTitle>}
      {text && <DialogContentText sx={{ m: 2 }}>{text}</DialogContentText>}
      <DialogActions sx={{ justifyContent: 'center', p: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            bgcolor: theme.primary,
            color: theme.text1,
            fontSize: '18px',
            width: '25%',
            '&:hover': { bgcolor: theme.primary, color: theme.text1 },
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </CustomDialogModal>
  );
};

export default InfoDialogModal;
